"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lightColors = exports.lightPalette = void 0;
// From https://www.figma.com/file/KVhO35mvbPtasYVRbBtg8W/Heritage-%2F-Design-System?type=design&node-id=1-154&t=W53Tyn9lphm4s4Jt-4
const invariant_1 = require("./invariant");
// The specific colors for the light theme
exports.lightPalette = {
    text900: "#1C1C1C",
    accent: "#2E5EB8",
    accentLight: "#4381FF",
    accentBg100: "#EBF4FD",
    accentBg200: "#C9DDF0",
    backgroundPage: "#EFEDE7",
    backgroundCard: "#FFFFFF",
    neutral300: "#E1E1E1",
    neutral500: "#B6BDC2",
    neutral700: "#687076",
    statusNegative: "#EB482F",
    statusNegativeLight: "#FF644D",
    statusPositive: "#42B85A",
    statusPositiveLight: "#54D16D",
    chart100: "#419E9B",
    chart200: "#29818E",
    chart300: "#23637A",
    chart400: "#244761",
    chart500: "#222D44",
    chart600: "#62436D",
    chart700: "#AF5477",
    chart800: "#EA7663",
    chart900: "#FBB245"
};
// All the light colors, including also the invariant ones
exports.lightColors = {
    ...exports.lightPalette,
    ...invariant_1.invariantColors
};
